import React, { Component } from "react";
import TransitionLink, {
  TransitionPortal,
} from "gatsby-plugin-transition-link";
import { TimelineMax, Power4 } from "gsap";
import { Div, scrollTo } from "atomize";
import { Link } from "gatsby";

export default class AnimateLink extends Component {
  constructor(props) {
    super(props);

    this.vertical = this.vertical.bind(this);
    this.cover = null;
  }

  // componentDidMount() {
  //   this.cover = document.querySelector(
  //     ".gatsby-plugin-transition-link-portal #transitionSection"
  //   );
  // }

  vertical = ({ node, props: { length: seconds }, direction }) => {
    const { goTo } = this.props;
    const directionTo = "-100%";
    const directionFrom = "100%";
    const wait = seconds / 6;
    const half = (seconds - wait) / 2;

    this.cover = document.querySelector("#transitionSection");

    return new TimelineMax()
      .set(this.cover, { y: directionFrom })
      .to(this.cover, half, {
        y: "0%",
        ease: Power4.easeInOut,
      })
      .set(node, { opacity: 0 })
      .to(
        this.cover,
        half,
        {
          y: directionTo,
          ease: Power4.easeIn,
          onComplete: () => {
            if (goTo) {
              scrollTo(goTo, 100);
              // const element = document.querySelector(goTo)
              // if (element) {
              //   const distance = element.offsetTop - 100
              //   window.scrollTo(0, distance)
              // }
            }
          },
        },
        `+=${wait}`
      );
  };

  render() {
    const direction = this.props.direction || "left";
    const length = this.props.duration || 1.5;
    const {
      exit: removedExit,
      entry: removedEntry,
      cover: removedProp,
      bg,
      children,
      to,
      ...rest
    } = this.props;

    return (
      <>
        {/* <TransitionLink
          exit={{
            length: length,
            trigger: ({ exit, node }) =>
              this.vertical({ props: exit, node, direction }),
          }}
          entry={{
            delay: length / 2,
          }}
          to={to}
          {...props}
        >
          {children}
        </TransitionLink> */}

        <Link to={to} {...rest}>
          {children}
        </Link>

        {/* <TransitionPortal>
          <Div
            ref={n => (this.cover = n)}
            bg={bg}
            pos="fixed"
            top="0"
            left="0"
            h="100vh"
            w="100vw"
            transform="translateY(100%)"
          />
        </TransitionPortal> */}
      </>
    );
  }
}

AnimateLink.defaultProps = {
  bg: "#111111",
};
